import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GenericsService} from '../../services/generics.service';
import {TokenStorageService} from '../../services/token-storage.service';
import {ActivityService} from 'ng-metro4';
import {ActivatedRoute} from '@angular/router';
import {CommunicationService} from '../../services/communication.service';
import {ModelDataFactory} from '../bdc-reglements-factory/model-factory';

@Component({
  selector: 'app-table-factory',
  templateUrl: './table-factory.component.html',
  styleUrls: ['./table-factory.component.css']
})
export class TableFactoryComponent implements OnInit {

  @Input() configComponent: ModelDataFactory;
  @Input() dataMapper: any[];
  @Input() dataApi: any[];
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();
  @Output() onReject: EventEmitter<any> = new EventEmitter();
  @Output() objectSelected: EventEmitter<any> = new EventEmitter();
  @Output() objectSelectedDoubleClick: EventEmitter<any> = new EventEmitter();
  @Output() onChangePageEmit: EventEmitter<any> = new EventEmitter();
  @Input() keyTab: string;
  @Input() size: number;
  @Input() totalItems: number;
  normalizedData: any[] = [];
  currentUrl: any;
  currentObject: any;

  page = 0;
  sort = 'ASC';
  orderBy = 'id';
  urlListing = '';
  token = '';
  attributeMapping: { [key: string]: string };
  constructor(
    public genericsService: GenericsService,
    private tokenStorageService: TokenStorageService,
    private activityService: ActivityService,
    private route: ActivatedRoute,
    private communicationService: CommunicationService
  ) { }

  ngOnInit(): void {
    // this.communicationService.dataSubjectFunction$.subscribe((val: string) => {
    //
    //   this.fetchData('');
    // });
    this.attributeMapping = this.configComponent.attributeMapping;
    // this.tableHeaders = this.configComponent.tableHeaders;
    this.urlListing = this.configComponent.urlListing;
    this.currentUrl = this.route?.snapshot?.params;

    // this.fetchData(this.token);
  }
  getItemHeaderToSort(header: any): void {
    this.orderBy = this.currentCol(header);
  }
  currentCol(header: any): string {
    const item = header.field.split('.');
    return item[item.length - 1];
  }
  getFieldValue(row: any, field: string): any {

    if (!row || !field) {
      return '';
    }

    // si le champ n'est pas imbriqué
    if (!field.includes('.')) {
      return row[field];
    }

    // gestion des champs imbriqués
    return field.split('.').reduce((obj: any, key: string) => {
      return obj && obj[key] !== undefined ? obj[key] : null;
    }, row);
  }
  // public fetchData(keyword): void {
  //   const activity =  this.activityService.open({
  //     style: 'color',
  //     text: '<div class="mt-2 display1 fg-darkBlue">Loading ...</div>',
  //     type: 'cycle',
  //     overlayColor: '#a7a0a0',
  //   });
  //   this.genericsService.getResource(`${this.urlListing}?keyword=${keyword}&page=${this.page}&size=${this.size}&sort=${this.sort}&orderBy=${this.orderBy}`).then((result: any) => {
  //
  //     console.log(result);
  //     this.currentObject = null;
  //     this.activityService.close(activity);
  //     if (result.success) {
  //       // this.normalizeData(result.data ? result.data : []);
  //       this.dataApi = result.data.content ? result.data.content : [];
  //       this.totalItems = result.data.totalElements;
  //     }
  //   }).catch((error) => {
  //     this.activityService.close(activity);
  //   });
  // }
  // getFieldValue(row: any, field: string): any {
  //   return field.split('.').reduce((obj, key) => (obj ? obj[key] : null), row);
  // }

  isSelected(row: any): boolean {
    if (!this.currentObject) { return false; }
    if (this.keyTab) {
      return row[this.keyTab] === this.currentObject[this.keyTab];
    }
    return row.id === this.currentObject.id;
  }

  onSelect(obj: any): void {
    this.currentObject = obj;
    this.objectSelected.emit(obj);
  }

  onSelectDoubleClick(obj: any): void {
    this.currentObject = obj;
    this.objectSelectedDoubleClick.emit(obj);
  }

  onChangePage(event): void {
    this.page = event - 1;
    // this.fetchData('');
    this.onChangePageEmit.emit(this.page);
  }
}
